import React from "react";
import PropTypes from "prop-types";

export const Vara = ({ name, image, description }) => {
  return (
    <div className="flex flex-col w-[90%] md:flex-row bg-white rounded-xl border border-amber-100 shadow hover:shadow-md transition-shadow overflow-hidden m-3 md:w-[45%] md:min-h-[12rem]">
      <img src={image} alt={name} className="object-cover w-full h-48 flex-shrink-0 md:w-48 md:h-auto" />
      <div className="p-5">
        <h3 className="block mt-1 text-xl leading-tight font-serif font-semibold text-stone-900">{name}</h3>
        <p className="mt-2 text-stone-500 font-serif text-sm">{description}</p>
      </div>
    </div>
  );
}

export default Vara;

Vara.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};